<template>
  <div class="chart">
    <canvas :id="id" class="chart-canvas" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto"

export default {
  name: "HorizontalBarChart",
  props: {
    id: {
      type: String,
      default: "chart-bar"
    },
    height: {
      type: [String, Number],
      default: "200"
    },
    chart: {
      type: Object,
      required: true,
      labels: Array,
      datasets: {
        type: Array,
        label: String,
        data: Array
      }
    }
  },
  mounted() {
    var ctx3 = document.getElementById(this.id).getContext("2d")

    // Bar chart
    new Chart(ctx3, {
      type: "bar",
      data: {
        labels: this.chart.labels,
        datasets: [
          {
            label: this.chart.datasets[0].label,
            weight: 5,
            borderWidth: 0,
            borderRadius: 4,
            backgroundColor: "#3A416F",
            data: this.chart.datasets[0].data,
            fill: false
          }
        ]
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: true,
              drawOnChartArea: true,
              drawTicks: false,
              borderDash: [5, 5]
            },
            ticks: {
              display: true,
              padding: 10,
              color: "#9ca2b7",
            }
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: true,
              drawTicks: true
            },
            ticks: {
              display: true,
              color: "#9ca2b7",
              padding: 10,
              callback: function(value) { if (value % 1 === 0) { return value; } }
            }
          }
        }
      }
    })
  }
}
</script>
